<button mat-icon-button class="disabledWhite" *ngIf="!isFromActionList" [disabled]="selectionModel.selected.length === 0 || selectionModel.selected.length > 50" (click)="printDocument(selectionModel.selected)">
  <mat-icon>print_outline</mat-icon>
</button>


<button mat-menu-item class="disabledWhite" *ngIf="isFromActionList" [class.fromActionList]="isFromActionList" [disabled]="selectionModel.selected.length === 0 || selectionModel.selected.length > 50" (click)="printDocument(selectionModel.selected)">
  <mat-icon>print_outline</mat-icon>
  <span>Imprimer</span>
</button>
